import core, { View } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { useMemoSelector } from 'hooks';

const {
    entities: {
        selectors: { selectMarket },
    },
} = core;

interface Input {
    marketId: string;
}

interface Output {
    market: View.Market | null;
}

export default function useMarket({ marketId }: Input): Output {
    const { market } = useMemoSelector(makeSelectProps(), { marketId });

    return {
        market,
    };
}

const makeSelectProps = () => {
    return createStructuredSelector({
        market: selectMarket,
    });
};
